import { RouteObject } from "react-router-dom";
import Home from "../Pages/Home";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/:partialLink",
    element: <Home />,
  },
];

export default routes;
